<template>
  <div id="venues">
    <div class="content-wrapper">
      <portal to="action-buttons">
        <ul class="navbar-nav ml-md-auto" v-if="true">
          <li class="nav-item">
            <el-button
              icon="fas fa-plus"
              type="primary"
              size="small"
              round
              @click="
                venueId = null;
                modalVisible = true;
              "
            >
              {{ $t("onsiteUtilities.controlPoints.createControlPoint") }}
            </el-button>
          </li>
        </ul>
      </portal>

      <div class="content animated fadeIn">
        <div class="card">
          <div class="card-header">
            <div class="card-title-container">
              <h5 class="card-title">{{ this.$t("event.menu.controlpoints.title") }}</h5>
              <span v-if="$store.state.venues.items.length > 0 && true" v-html="$t('totalContent', [$store.state.venues.items.length])"></span>
            </div>

            <div class="header-elements">
              <el-button-group>
                <el-tooltip class="item" effect="dark" :content="$t('event.buttons.helpdesk')" placement="top">
                  <el-button @click="$helpMe('https://holacon.com/product-guide/detail/how-to-create-and-manage-control-points')" icon="fas fa-life-ring" size="mini" round></el-button>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" :content="$t('event.buttons.refresh')" placement="top">
                  <el-button type="success" :icon="loading == 'loadingList' ? 'el-icon-loading' : 'fas fa-redo-alt'" size="mini" @click="refreshList" round></el-button>
                </el-tooltip>
              </el-button-group>
            </div>
          </div>
          <div class="card-body" v-if="false">
            <upgrade-overlay height="200px"></upgrade-overlay>
          </div>
          <div class="card-body" v-else-if="$store.state.venues.items.length > 0">
            <div class="control-point-container">
              <div class="custom-grid-table-header controlpoints-grid-template">
                <!-- <div>
                  <i v-show="loading == 'loadingList'" class="el-icon-loading"></i>
                </div> -->
                <span>{{ $t("onsiteUtilities.controlPoints.title") }}</span>
                <span>{{ $t("onsiteUtilities.controlPoints.controlType") }}</span>
                <!-- <span>Canlı Oturum</span>
                <span>Networking odası</span> -->
                <span>{{ $t("onsiteUtilities.controlPoints.view") }}</span>
                <span></span>
              </div>
              <div class="control-point-item-area">
                <div class="item" v-for="item in $store.state.venues.items" :key="item.id" :class="{ passive: !item.isActive }">
                  <div class="area-1">
                    <!-- <div><i class="el-icon-s-grid burger"></i></div> -->
                    <div class="venue-title">
                      {{ item.title }}
                      <span>{{ getEnumsDisplay("ControlPointType", item.controlPointType) }}</span>
                    </div>
                    <div class="access-typer" :class="'type-' + item.type" @click="item.show = !item.show">{{ getEnumsDisplay("AccessType", item.type) }}</div>
                    <!-- <div><div class="count-info">114</div></div>
                    <div><div class="count-info">114</div></div> -->
                    <div><el-switch v-model="item.isActive" @change="toggleItem(item.id)"></el-switch></div>
                    <div class="action-btns d-flex justify-content-end">
                      <el-tooltip class="item" effect="dark" :content="$t('onsiteUtilities.controlPoints.seatingArrangement')" placement="top">
                        <el-button icon="fas fa-chair" @click="openSeatingModal(item.id)" size="mini" type="warning" circle></el-button>
                      </el-tooltip>
                      <el-tooltip class="item" effect="dark" :content="$t('event.table.entryRecords')" placement="top">
                        <el-button
                          type="success"
                          icon="el-icon-user-solid"
                          circle
                          size="mini"
                          @click="
                            activeVenueId = item.id;
                            $store.state.accesslogs.filter.skip = 0;
                            logModal = true;
                          "
                        ></el-button>
                      </el-tooltip>
                      <el-tooltip class="item" effect="dark" :content="$t('event.table.edit')" placement="top">
                        <el-button
                          class="ml-0"
                          type="primary"
                          icon="fas fa-pen"
                          circle
                          size="mini"
                          @click="
                            venueId = item.id;
                            modalVisible = true;
                          "
                        ></el-button>
                      </el-tooltip>
                      <el-tooltip class="item" effect="dark" :content="$t('event.table.delete')" placement="top">
                        <el-popconfirm @confirm="deleteItem(item.id)" :confirmButtonText="$t('event.variables.yes')" :cancelButtonText="$t('event.buttons.cancel')" icon="el-icon-info" iconColor="red" :title="$t('event.textbox.toDelete')">
                          <el-button slot="reference" :loading="loading == 'deleteItem-' + item.id" type="danger" icon="fas fa-trash" circle size="mini"></el-button>
                        </el-popconfirm>
                      </el-tooltip>
                    </div>
                  </div>
                  <el-collapse-transition>
                    <div class="area-2" v-show="item.show">
                      <div class="timer-area" v-if="item.enableTimeRestriction">
                        <i class="fa fa-user-clock"></i>

                        <template v-if="$i18n.locale == 'tr'">{{ item.startTime + " - " + item.endTime }} saatleri arasına giriş kısıtlaması tanımlanmış.</template>

                        <template v-else>An entry restriction has been defined between {{ item.startTime + " - " + item.endTime }}</template>
                      </div>

                      <div class="timer-area" v-if="item.details">
                        <i class="fas fa-sticky-note"></i>
                        <div v-html="item.details"></div>
                      </div>

                      <div class="area-info-container">
                        <div class="selected-cont" v-if="item.tags.length > 0">
                          <div class="selected-title">{{ item.type == 1 ? $t("onsiteUtilities.controlPoints.allTags") : $t("onsiteUtilities.controlPoints.selectedTags") }}</div>
                          <div class="group-tags-container" v-if="$store.state.tags.items.length > 0">
                            <template v-for="tag in item.tags">
                              <div class="tag-item" :key="tag + 'tagselected'" v-if="$store.state.tags.items.find(x => x.id == tag)">
                                <i class="fas fa-circle" :style="{ color: $store.state.tags.items.find(x => x.id == tag).color }"></i>
                                <span>{{ $store.state.tags.items.find(x => x.id == tag).title }}</span>
                              </div>
                            </template>
                          </div>
                        </div>

                        <div class="selected-cont" v-if="item.subEventIds.length > 0">
                          <div class="selected-title">{{ $t("onsiteUtilities.controlPoints.selectedTitle1") }}</div>
                          <div class="group-tags-container" v-if="$store.state.subevents.items.length > 0">
                            <div class="tag-item" v-for="subevent in item.subEventIds" :key="subevent + 'subeventselected'">
                              <i class="fas fa-circle"></i>
                              <span>{{ $store.state.subevents.items.find(x => x.id == subevent) ? $store.state.subevents.items.find(x => x.id == subevent).title : "" }}</span>
                            </div>
                          </div>
                        </div>

                        <div class="selected-cont subevent" v-if="item.availableSessionIds.length > 0">
                          <div class="selected-title">{{ $t("onsiteUtilities.controlPoints.selectedTitle2") }}</div>
                          <div class="group-tags-container" v-if="$store.state.livesessions.items.length > 0">
                            <div class="tag-item" v-for="session in item.availableSessionIds" :key="session + 'sessionselected'">
                              <i class="fas fa-circle"></i>
                              <span v-if="$store.state.livesessions.items.find(x => x.id == session)">{{ $store.state.livesessions.items.find(x => x.id == session).title }}</span>
                            </div>
                          </div>
                        </div>

                        <div class="selected-cont subevent" v-if="item.availableNetworkingAreaIds.length > 0">
                          <div class="selected-title">{{ $t("onsiteUtilities.controlPoints.selectedTitle3") }}</div>
                          <div class="group-tags-container" v-if="$store.state.networking.items.length > 0">
                            <div class="tag-item" v-for="network in item.availableNetworkingAreaIds" :key="network + 'networkselected'">
                              <i class="fas fa-circle"></i>
                              <span v-if="$store.state.networking.items.find(x => x.id == network)">{{ $store.state.networking.items.find(x => x.id == network).title }}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </el-collapse-transition>
                </div>
              </div>
            </div>
          </div>
          <div v-else>
            <HolaconLottieNoData
              class="w-100"
              key="create-loading"
              :source="'holacon-access-control-lottie'"
              :title="$t('event.menu.controlpoints.title')"
              @btnAdd="
                venueId = null;
                modalVisible = true;
              "
              @btnRefresh="refreshList()"
              :buttonAdd="true"
              :buttonRefresh="true"
              :loading="loading"
            />
          </div>
          <div class="card-footer"></div>
        </div>
      </div>
    </div>

    <el-dialog :close-on-click-modal="false" :visible.sync="modalVisible" :title="venueId ? $t('onsiteUtilities.controlPoints.editControlPoint') : $t('onsiteUtilities.controlPoints.createControlPoint')" class="large" center modal-append-to-body destroy-on-close>
      <VenueAddUpdate @deleteMe="deleteItem" @closeDialog="modalVisible = false" v-if="modalVisible" :id="venueId" />
    </el-dialog>

    <el-dialog :close-on-click-modal="false" :visible.sync="logModal" :title="$t('event.table.entryRecords')" class="xlarge" center modal-append-to-body destroy-on-close>
      <ControlPointAccessLogs :key="logModal" @closeDialog="logModal = false" :activeVenue="activeVenueId" v-if="logModal" />
    </el-dialog>

    <el-dialog :visible.sync="seatingDialog" center modal-append-to-body destroy-on-close :title="$t('event.table.seatingPllaner')">
      <SeatingManagement v-if="seatingDialog" @closeDialog="seatingDialog = false" :venueId="seatingVenueId" />
    </el-dialog>
  </div>
</template>

<script>
import VenueAddUpdate from "../../components/VenueAddUpdate";
import ControlPointAccessLogs from "../../components/automatedmessages/ControlPointLogs.vue";
import AccessLogs from "../../pages/event/AccessLogs";
import axios from "axios";
import SeatingManagement from "../../components/SeatingManagement.vue";
import PageCountInfo from "../../components/PageCountInfo";
import $ from "jquery";
export default {
  metaInfo() {
    return {
      title: this.$t("eventPageTitle.controlPoint")
    };
  },
  components: { VenueAddUpdate, PageCountInfo, AccessLogs, ControlPointAccessLogs, SeatingManagement },
  name: "Venues",
  data() {
    return {
      seatingVenueId: null,
      seatingDialog: false,
      activeVenueId: null,
      venueId: null,
      axios,
      modalVisible: false,
      updateForm: null,
      loading: false,
      listShort: null,
      isFilterEnabled: false,
      timeout: null,
      excelDialog: false,
      helpUrl: this.$helpUrl + "tags",
      logModal: false
    };
  },
  methods: {
    openSeatingModal(id) {
      if (id != null) {
        this.seatingVenueId = id;
        this.seatingDialog = true;
      } else {
        this.seatingVenueId = null;
        this.seatingDialog = false;
      }
    },
    handleSizeChange(take) {
      this.$store.commit("setVenueTake", take);
    },
    handleCurrentChange(page) {
      $("html, body").animate({ scrollTop: 0 }, 350);
      this.$store.commit("setVenuePage", page);
    },
    deleteItem(id) {
      this.loading = "deleteItem-" + id;
      if (this.timeout != null) clearTimeout(500);
      this.timeout = setTimeout(async () => {
        var res = await this.$store.dispatch("deleteVenue", id);
        if (!res.data.alert.hasError) {
          await this.$store.dispatch("getVenues");
        }
        this.loading = false;
      }, 500);
    },

    handleSelectionChange(items) {
      this.$store.commit("setSelectedVenues", items);
    },
    tableRowClassName({ row, rowIndex }) {
      if (row.isActive) {
        return "row-active";
      }
      return "row-passive";
    },
    async refreshList() {
      if (this.listShort != null) clearTimeout(this.listShort);
      this.loading = "loadingList";
      await this.$store.dispatch("getVenues");
      this.listShort = setTimeout(async () => {
        this.loading = false;
      }, 500);
    },
    async toggleItem(id) {
      await this.$store.dispatch("togglerVenue", id);
    }
  },
  async mounted() {
    this.loading = "loadingScreen";
    if (this.timeout != null) clearTimeout(this.timeout);
    this.timeout = setTimeout(async () => {
      await this.$store.dispatch("getTags");
      await this.$store.dispatch("getNetworkings");
      await this.$store.dispatch("getVenues");
      this.loading = false;
    }, 500);
  },
  async created() {
    await this.$store.dispatch("getSubEvents");
  },
  computed: {
    eventPermissions() {
      return this.$store.getters.getEventPermission;
    },
    skip() {
      return (this.$store.state.venues.filter.page - 1) * this.$store.state.venues.filter.take;
    },
    take() {
      return this.skip + this.$store.state.venues.items.length;
    }
  },
  watch: {
    "$store.state.venues.filter.searchTerm": function() {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.$store.dispatch("getVenues");
      }, 500);
    }
  }
};
</script>
<style lang="less" scoped>
.modal-base-small {
  min-width: 500px;
}

.control-point-container {
  .controlpoints-grid-template {
    grid-template-columns: 1fr 1fr 90px 120px;
  }
  .control-point-item-area {
    display: flex;
    flex-direction: column;
    & > .item {
      transition: all 0.5s;
      border-radius: 8px;
      display: flex;
      flex-direction: column;
      background-color: #f1f1f1;
      margin-bottom: 8px;

      &:last-child {
        margin-bottom: unset;
      }
      &.passive {
        background-color: #fff2f2 !important;
      }
      .area-1 {
        i.burger {
          box-sizing: border-box;
          font-size: 20px;
          color: #505763;
          &.me {
            color: #ccc;
          }
        }
        .venue-title {
          display: flex;
          flex-direction: column;
          color: #292f3b;
          font-weight: 600;
          span {
            font-weight: 500;
            color: #505763;
          }
        }
        .access-typer {
          cursor: pointer;
          font-weight: bold;
          text-decoration: underline;
          &.type-1 {
            color: #03658c;
          }
          &.type-2 {
            color: #ff7511;
          }
          &.type-3 {
            color: #ff6565;
          }
        }
        .action-btns {
          gap: 4px;
          button {
            &:nth-child(2) {
              margin-left: unset !important;
            }
          }
        }

        padding: 10px;
        display: grid;
        grid-template-columns: 1fr 1fr 90px 120px;
        gap: 0.5rem;
        align-items: center;
        .btn-area {
          display: flex;
          justify-content: flex-end;
          align-items: center;
        }
      }
      .area-2 {
        padding: 10px;
        .timer-area {
          display: flex;
          gap: 0.5rem;
          font-weight: 400;
          color: #292f3b;
          i {
            font-size: 16px;
            font-weight: bold;
            color: #03658c;
          }
          margin-bottom: 1rem;
        }
        .area-info-container {
          display: grid;
          margin-bottom: 10px;

          &:last-child {
            margin-bottom: unset;
          }
          .selected-title {
            margin-bottom: 0.5rem;
            font-size: 13px;
            color: #292f3b;
            font-weight: 600;
          }
          .selected-cont {
            margin-bottom: 10px;
            &:last-child {
              margin-bottom: unset;
            }
          }
          .selected-items {
            &.tags {
              display: grid;
              gap: 0.5rem;
              grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;
            }
            &.subevent {
              display: grid;
              gap: 0.5rem;
              grid-template-columns: 1fr 1fr 1fr;
            }
          }
        }
      }
    }
  }
}
.count-info {
  padding: 5px 10px;
  width: max-content;
  border-radius: 8px;
  background-color: rgba(255, 255, 255, 0.8);
  font-weight: 600;
  color: #505763;
  font-size: 13px;
}
.tca {
  display: flex;
  align-items: center;
  justify-content: center;
}

.circle-color-pick {
  width: 15px;
  height: 15px;
  border-radius: 50%;
}
</style>



// WEBPACK FOOTER //
// src/pages/event/Venues.vue